












































import Vue from "vue";
export default Vue.extend({
  name: "CustomCheckbox",
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click(e: MouseEvent): void {
      this.$emit("click", e);
    },
    classes(): string {
      let classes = [];
      this.checked ? classes.push("container_color") : classes.push("empty_container_color");
      return [...classes, "container_checkbox"].join(" ");
    }
  }
});
